module.exports = __webpack_public_path__ + "static/media/warranty_part1.1ce1eaac.png";